import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ClockIcon } from 'lucide-react';
import { SectionHeading } from '../components/SectionHeading';
import { Button } from '../components/Button';
import { INSIGHTS } from '../data/site';
export function InsightsPreview() {
  return <section id="insights" className="w-full scroll-mt-20 bg-cream py-20 lg:py-28" data-id="element-554">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-555">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-556">
          <SectionHeading eyebrow="Insights" title="Real problems. Practical systems thinking." body="No invented client results — just the recurring system problems we see in mine geology, and how the framework helps. Case study themes are being written now." data-id="element-557" />
          <Button variant="secondary" as="a" href="#insights" className="shrink-0" data-id="element-558">
            Explore Insights
          </Button>
        </div>

        <div className="mt-12 grid items-stretch gap-6 md:grid-cols-2" data-id="element-559">
          {INSIGHTS.slice(0, 4).map((a, i) => <motion.article key={a.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="group flex h-full flex-col rounded-xl border border-charcoal/10 bg-sand p-6 shadow-card transition-transform duration-200 hover:-translate-y-1" data-id="element-560">
              <div className="flex items-center gap-3" data-id="element-561">
                <span className="rounded-full px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-white" style={{
              backgroundColor: a.categoryColor
            }} data-id="element-562">
                  {a.category}
                </span>
                <span className="rounded-full bg-charcoal/8 px-2.5 py-1 text-xs font-bold text-warmgray" data-id="element-563">
                  {a.status}
                </span>
              </div>
              <h3 className="mt-4 text-xl font-bold leading-snug text-charcoal" data-id="element-564">
                {a.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-warmgray" data-id="element-565">
                {a.summary}
              </p>
              <div className="mt-auto flex items-center justify-between border-t border-charcoal/10 pt-4" data-id="element-566">
                <span className="inline-flex items-center gap-1.5 text-xs text-warmgray" data-id="element-567">
                  <ClockIcon className="h-3.5 w-3.5" data-id="element-568" />
                  {a.readTime}
                </span>
                <span className="inline-flex items-center gap-1.5 text-sm font-bold text-charcoal" data-id="element-569">
                  Read insight
                  <ArrowRightIcon className="h-4 w-4 text-yellow transition-transform group-hover:translate-x-0.5" data-id="element-570" />
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}